import { IEntityWithSoftDeleteDto } from "@Interfaces/IEntities";
import { z } from "zod";
import { CityResponseDto } from "./city-dto";
import { SocialMediaDTo, VenueResponseDto } from "./venue-dto";
// Get
export interface EntityResponseDto extends IEntityWithSoftDeleteDto {
    id?: string;
    name?: string;
    description?: string;
    phone?: string;
    commission?: number;
    email?: string;
    location?: string;

    cityId?: string;
    city?: CityResponseDto;
    socialMedias?: SocialMediaDTo[];
    images?: EntityImageDto[];
    venues?: VenueResponseDto[];
}

export interface EntityExtraDto {
    id: string;
    entityId: string;
    name: string;

    description: string;
    price: number;
    isOptional: boolean;
}

export const socialMediaSchema = z.object({
    type: z.string().optional(),
    link: z.string().optional(),
});

// zod schema
export const entityFormSchema = z.object({
    id: z.string().optional(),
    name: z.string().trim().min(1, { message: "Name is required" }),
    description: z.string().optional(),
    phone: z.string().optional(),
    email: z.string().email({ message: "Invalid email" }),
    location: z.string().optional(),
    countryId: z.string().optional(),
    cityId: z.string().optional(),
    images: z.array(z.instanceof(File)).optional().default([]),
    socialMedias: z.array(socialMediaSchema).default([]),
});

// zod infer
export type EntityFormDto = z.infer<typeof entityFormSchema>;

export type SocialMediaDto = z.infer<typeof socialMediaSchema>;

export interface EntityImageDto {
    path: string;
}